module.exports = __webpack_public_path__ + "img/azeem.8b5ba711.jpg";